module.exports = __webpack_public_path__ + "static/media/Dewpider_gaussian2.40222a3c.png";